import { ErrorBoundary } from "@magalu/rave/errorBoundary";
import { PlatformHooksProvider } from "@magalu/ravejs-platform-hooks";
import { useRouter } from "next/compat/router";
import React, { useEffect } from "react";
import { useFeatureFlag } from "@hooks/useFeatureFlag";
import DataDogRum from "@modules/DataDogRum/DataDogRum";
export const render = ({ Component, pageProps }) => {
    const router = useRouter();
    const { channelName, isLoaded } = useFeatureFlag();
    const handleRedirectErrorBoundary = () => {
        router.replace("/error");
        return null;
    };
    const appOnError = (e, errorInfo) => {
        console.error(e);
        console.error(errorInfo);
    };
    useEffect(() => {
        if (isLoaded) {
            // eslint-disable-next-line no-console
            console.info("%c 🛒 %s v%s ", "background:#0086ff; color:#fff; padding:2px 0;", channelName, __APP_VERSION__);
        }
    }, [isLoaded, channelName]);
    return (<div id="rave-imperio">
      <PlatformHooksProvider config={pageProps === null || pageProps === void 0 ? void 0 : pageProps.manifest}>
        <ErrorBoundary onError={appOnError} onRenderWithError={handleRedirectErrorBoundary}>
          <DataDogRum>
            <Component {...pageProps}/>
          </DataDogRum>
        </ErrorBoundary>
      </PlatformHooksProvider>
    </div>);
};
